import {
  UIStatus,
  WQIGroupKey,
} from '../store/waterQualityIndex/waterQualityIndex.types'
import {
  WQI_GROUP_LABELS,
  WQI_GROUP_ORDER,
} from '../store/waterQualityIndex/groupLabels'

const STATUS_TO_EMOJI: Record<UIStatus, string> = {
  safe: '🟩',
  cautious: '🟨',
  unsafe: '🟥',
}

const STATUS_TO_LABEL: Record<UIStatus, string> = {
  safe: 'Safe',
  cautious: 'Cautious',
  unsafe: 'Unsafe',
}

export interface ShareGroup {
  groupKey: WQIGroupKey
  status: UIStatus
}

export interface GenerateWqiShareStringInput {
  overallStatus: UIStatus
  groups: ShareGroup[]
  shareUrl: string
}

// Produces a Wordle-style copy-paste block that renders well in Slack,
// iMessage, X, etc. Order follows WQI_GROUP_ORDER regardless of the input
// array's order; missing groups are omitted rather than defaulted.
export const generateWqiShareString = ({
  overallStatus,
  groups,
  shareUrl,
}: GenerateWqiShareStringInput): string => {
  const groupByKey = new Map(groups.map((g) => [g.groupKey, g]))

  const groupLines = WQI_GROUP_ORDER
    .map((key) => {
      const group = groupByKey.get(key)
      if (!group) return null
      return `${STATUS_TO_EMOJI[group.status]} ${WQI_GROUP_LABELS[key]}`
    })
    .filter((line): line is string => line !== null)

  return [
    'My SIPP Water Report',
    `Overall: ${STATUS_TO_EMOJI[overallStatus]} ${STATUS_TO_LABEL[overallStatus]}`,
    '',
    ...groupLines,
    '',
    `Get yours: ${shareUrl}`,
  ].join('\n')
}
